import React from "react";
import { IPostViewersListModalProps } from "./PostViewersListModal.types";

const PostViewersListModal = React.lazy(() => import("./PostViewersListModal"));

const LazyLoadedPostViewersListModal = (props: IPostViewersListModalProps) => {
  return (
    <React.Suspense fallback={null}>
      <PostViewersListModal {...props} />
    </React.Suspense>
  );
};

export default LazyLoadedPostViewersListModal;
